module.exports = __webpack_public_path__ + "img/s1.ea43bf2e.png";